// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control {
  padding: 6px 5px !important;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.form-select:focus,
.form-control:focus,
.form-select:focus-visible,
.form-control:focus-visible {
  border-color: transparent;
  box-shadow: none;
  outline: 1px solid rgba(0, 0, 0, 0.39);
}
.css-1u9des2-indicatorSeparator {
  background-color: transparent !important;
}

.react-select {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px !important;
}
.css-13cymwt-control {
  box-shadow: none !important;
  border-color: transparent;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.card {
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.119);
  padding: 20px;
  width: 33%;
  max-width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  text-align: center;
  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;
  transition: 0.3s;
}
.card_img {
  width: 50px;
  height: 50px;
}
.font_weight_700 {
  font-weight: 700;
  font-size: 14px;
}
.card_second {
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.119);
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  width: 45%;
  text-align: center;
  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;
  transition: 0.3s;
}
.quick_action img {
  width: 60px;
  height: 60px;
  object-fit: contain;
}
.left_line {
  background: #042998;
  height: 30px;
  width: 4px;
  border-radius: 0 10px 10px 0;
}
.text_blue {
  color: #042998;
}
.accordion_title {
  background-color: #d6e5f9;
  border: 1px solid #abcdfaba;
  padding: 20px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  color: #042998;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
`, "",{"version":3,"sources":["webpack://./src/Admin/AdminHome/index.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,iDAAiD;AACnD;AACA;;;;EAIE,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4DAA4D;AAC9D;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,cAAc;AAChB;AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B","sourcesContent":[".form-control {\r\n  padding: 6px 5px !important;\r\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n}\r\n.form-select:focus,\r\n.form-control:focus,\r\n.form-select:focus-visible,\r\n.form-control:focus-visible {\r\n  border-color: transparent;\r\n  box-shadow: none;\r\n  outline: 1px solid rgba(0, 0, 0, 0.39);\r\n}\r\n.css-1u9des2-indicatorSeparator {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.react-select {\r\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px !important;\r\n}\r\n.css-13cymwt-control {\r\n  box-shadow: none !important;\r\n  border-color: transparent;\r\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n}\r\n\r\n.card {\r\n  background: white;\r\n  border-radius: 8px;\r\n  border: 1px solid rgba(0, 0, 0, 0.119);\r\n  padding: 20px;\r\n  width: 33%;\r\n  max-width: 200px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 5px;\r\n  text-align: center;\r\n  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;\r\n  transition: 0.3s;\r\n}\r\n.card_img {\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n.font_weight_700 {\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n}\r\n.card_second {\r\n  background: white;\r\n  border-radius: 8px;\r\n  border: 1px solid rgba(0, 0, 0, 0.119);\r\n  padding: 15px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 5px;\r\n  width: 45%;\r\n  text-align: center;\r\n  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;\r\n  transition: 0.3s;\r\n}\r\n.quick_action img {\r\n  width: 60px;\r\n  height: 60px;\r\n  object-fit: contain;\r\n}\r\n.left_line {\r\n  background: #042998;\r\n  height: 30px;\r\n  width: 4px;\r\n  border-radius: 0 10px 10px 0;\r\n}\r\n.text_blue {\r\n  color: #042998;\r\n}\r\n.accordion_title {\r\n  background-color: #d6e5f9;\r\n  border: 1px solid #abcdfaba;\r\n  padding: 20px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n  color: #042998;\r\n}\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Firefox */\r\ninput[type=\"number\"] {\r\n  -moz-appearance: textfield;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
